<template>
  <div class="study-container ">
    <el-header>
      <!-- <Header></Header> -->
    </el-header>
    <el-main>
      <div class="main-left">
        <el-drawer
            title=""
            :visible.sync="drawer"
            :direction="'ltr'">
          <div class="main-left-search">
            <div>
              <el-select clearable @change="getFollowUpTaskAllSpotCheck" v-model="spotCheckParams.seatId"
                         size="mini">
                <el-option v-for="(it,ind) in seatList" :value="it.id" :key="it.id"
                           :label="it.name"></el-option>
              </el-select>
            </div>
            <div v-if="spotCheckParams.qualityScreen != 1" @click="onlyGood">
              <el-button size="mini" type="primary">只看优质随访</el-button>
            </div>
            <div @click="onlyGood" v-else>
              <el-button size="mini">查看全部随访</el-button>
            </div>
          </div>
          <div class="drawer-inner-list">
            <div @click="getPatientDetail(item)" v-for="(item,index) in spotCheckList" :key="index"
                 class="list-item">
              <div>
                <span style="margin-right: 20px;">{{ item.seatUserInfos.name }}</span>
                <span>{{ item.followStatus }}</span>
              </div>
              <span v-if="item.isGood" style="position: relative;">
                                <img
                                    style="width: 50px;height: 50px;position: absolute;right: 0;top: 50%;transform: translateY(-50%)"
                                    src="./images/good.png" alt="">
                            </span>
            </div>
          </div>
          <el-pagination
              @current-change="currentChange"
              layout="prev, pager, next"
              :page-size="1"
              :total="spotCheckParams.totalPage">
          </el-pagination>
        </el-drawer>
      </div>
      <div class="main">
        <div @click="drawer = true" class="draw-bar">
          <div class="bar-left">
            <span>选</span>
            <span>择</span>
            <span>案</span>
            <span>例</span>
          </div>
          <div class="bar-right">
            <img src="./images/icon-right.png" alt="">
          </div>
        </div>
        <div class="page-left">
          <div class="user-card-container">
            <div style="text-align: left;">
              <el-button @click="$router.go(-1)" size="mini" type="primary">返回</el-button>
            </div>
            <UserCard ref="userCard" v-if="patientData.patientId && showComponent"
                      :patientData="patientData"></UserCard>
          </div>
          <div>
            <div style="width: 400px;margin-top: 10px;">
              <el-tabs type="border-card">
                <el-tab-pane label="参考信息">
                  <referenceInformation ref="referenceInfo"
                                        v-if="patientData.patientId&& showComponent"
                                        :patientData="patientData"></referenceInformation>
                </el-tab-pane>
                <el-tab-pane label="历史随访">
                  <followupHistoryList ref="followHistory"
                                       v-if="patientData.patientId&& showComponent"
                                       :patientData="patientData"></followupHistoryList>
                </el-tab-pane>
                <el-tab-pane label="抽查">
                  <div class="checklist">
                    <span
                        style="font-weight: 700;margin-bottom: 15px;display: inline-block">抽查时间：{{ currentSpotCheck.createTime }}</span>
                    <!--                                        {{currentSpotCheck.spotCheckRemarks}}-->
                    <div v-html="currentSpotCheck.spotCheckRemarks">

                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
        <div class="page-center">
          <div v-if="audioList.length && showAudio" class="audio-container">
            <div class="select-bar">
              <el-select placeholder="请选择录音" @change="getRecordList" size="mini" v-model="selectAudioId">
                <el-option v-for="(item,index) in audioList" :key="index" :value="item.id"
                           :label="`录音${index + 1}`"></el-option>
              </el-select>
            </div>
            <div class="audio-item">
              <audioPlayer v-if="showA" :src="audioSrc"></audioPlayer>
            </div>
          </div>
          <div class="question-container">
            <question-new v-if="showComponent && patientData.isNewTask" :admitNo="patientData.admitNo"
                          :taskId="getTaskCenterId"></question-new>
            <question-tree-node :infoId="patientData.followUpPatientInfoId" :questionDisabled="true"
                                v-if="showComponent && patientData.followupPatientId && qsLoaded && !patientData.isNewTask"
                                :patientId="patientData.followupPatientId" :taskId="getTaskCenterId"
                                ref="questionTreeNode"></question-tree-node>
          </div>
        </div>
        <div class="page-right study-detail"> 
          <div class="study-right ">
            <div class="label-box">
              <span class="one"></span>
              <span class="study-label" @click="showArticleDetail = false">随访材料</span>
              <el-select clearable @change="selectFloderHandler" size="mini" v-model="selectFloder">
                <el-option :label="item.folderName" :value="item.fileFolderId" v-for="(item,index) in floderList" :key="item.fileFolderId"></el-option>
              </el-select>
              <div v-if="showArticleDetail" style="text-decoration:underline;" @click="showArticleDetail = false">
                <span class="el-icon-arrow-right" style="font-weight: bold"></span>
                <span class="two">{{ studyContent.title }}</span>
                <span class="el-icon-circle-close" style="font-weight: bold"></span>
              </div>
            </div>
            <div class="study-list" v-show="!showArticleDetail">
              <div
                  @click="previewHandler(item)"
                  v-for="(item, index) in fileList"
                  :key="index"
                  class="article-item"
              >
                <span style="color:#000;font-size:15px;">{{ item.fileName }} <span v-if="item.showDot" style="color: red;font-size: 16px;font-weight: 700;margin-left: 15px;">新</span></span>
                <span class="el-icon-arrow-right"></span>
              </div>
            </div>

            <div class="article-detail ql-container" v-show="showArticleDetail">
              <div
                  id="studyPage"
                  style="min-height: 350px"
                  v-html="studyContent.content"
              ></div>
            </div>
            <div class="preview-dialog">
              <previewFileDialog :fullScreen="true" :title="'预览'" v-model="previewDialogVisible">
                <div v-if="previewStuff == 'office'" style="height: 86vh;" slot="pv">
                  <iframe
                      :src='previewSrc'
                      width='100%' height='100%'>
                  </iframe>
                </div>
                <div v-else-if="previewStuff == 'pdf'" style="height: 86vh;" slot="pv">
                  <iframe
                      :src='previewSrc'
                      width='100%' height='100%'>
                  </iframe>
                </div>
                <div v-else-if="previewStuff == 'video'" style="height: 86vh;" slot="pv">
                  <video autoplay controls style="width: 100%;height: 100%;" :src="previewSrc"></video>
                </div>
                <div v-else-if="previewStuff == 'audio'" style="height: 86vh;" slot="pv">
                  <audio autoplay controls style="width: 100%;height: 100%;" :src="previewSrc"></audio>
                </div>
                <div style="text-align: center" v-else-if="previewStuff == 'pic'" slot="pv">
                  <img v-viewer="{movable: true}" :src="previewSrc" alt="" style="width: 400px;">
                </div>
              </previewFileDialog>
            </div>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer>
      <Footer></Footer>
    </el-footer>

  </div>
</template>

<script>

import {
  RestNewFollowupCallCenterServiceGetStudyById,
  RestNewFollowupCallCenterServiceGetFollowUpTaskAllSpotCheck,
  RestNewFollowupCallCenterServiceGetSeatsByTaskId,
  RestNewFollowupCallCenterServiceGetFollowupTaskPatientInfo,
  RestFeedbackOutControllerGetFollowUpTaskPatientCallRecordList,
  RestNewFollowupCallCenterServiceGetALiRecording,
  RestNewFollowupCallCenterServiceGetStudyListByTask
} from '@src/assets/js/api.js'
import Header from "../common/Header";
import Footer from "../common/Footer";
import UserCard from '../patient/UserCard.vue'
import referenceInformation from '../referenceInformation/referenceInformation'
import followupHistoryList from '../referenceInformation/followupHistoryList'
import questionNew from '../question_Third/question'
import questionTreeNode from '../questionPreview/question-root-node-new'
import audioPlayer from '../AudioPlayer/vueAplayerN'
import {mapGetters, mapMutations, mapState} from 'vuex';
import previewFileDialog from '@/components/previewFileDialog'

export default {
  name: "studyPage",
  data() {
    return {
      previewDialogVisible: false,
      previewStuff: "",
      previewSrc: "",
      selectFloder: "",
      dialogVisible: true,
      studyTitle: "",
      currentSpotCheck: {},
      audioSrc: "",
      audioList: [],
      fileList: [],
      floderList: [],
      showArticleDetail: false,
      selectAudioId: null,
      qsLoaded: true,
      drawer: false,
      showComponent: true,
      patientData: {},
      spotCheckList: [],
      studyList: [],
      seatList: [],
      studyContent: {},
      spotCheckParams: {
        seatId: null,
        pageIndex: 1,
        totalPage: 1,
        qualityScreen: 0
      },
      showAudio: true,
      showA: false,
    }
  },
  computed: {
    ...mapGetters([
      'userid',
      'patientId',
      'taskValue',
      'username',
      'getTaskCenterId',
    ]),
    ...mapState([
      'user'
    ])
  },
  components: {
    Header,
    Footer,
    UserCard,
    referenceInformation,
    followupHistoryList,
    questionNew,
    questionTreeNode,
    audioPlayer,
    previewFileDialog
  },
  mounted() {
    this.init()
    this.getSeatsByTaskId()
    this.getFolderList({
      flag: 1
    })
    this.getFileList({
      folderId: null,
      flag: 2,
    }).then(res => {
      this.fileList = res.retValue
    })
  },
  methods: {
    previewHandler(params) {
      let office = ['.pptx', '.ppt', '.doc', '.docx', '.xls', '.xlsx',]
      let video = ['.mp4', '.avi', '.mpg', '.mpeg', '.mov', '.wmv']
      let audio = ['.mp3','.wav','.wma','.flac','.midi','.mov']
      this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceGetPreviewFileUrl',
        params: {
          fileId: params.id
        }
      }).then((res) => {
        this.previewStuff = params.fileSuffix
        if (office.indexOf(params.fileSuffix) != -1) {
          this.previewSrc = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(res.retValue)}&wdOrigin=BROWSELINK`
          this.previewStuff = 'office'
        } else if (params.fileSuffix == '.pdf') {
          this.previewSrc = `${res.retValue}`
          this.previewStuff = 'pdf'
        } else if (video.indexOf(params.fileSuffix) != -1) {
          this.previewSrc = `${res.retValue}`
          this.previewStuff = 'video'
        } else if (audio.indexOf(params.fileSuffix) != -1) {
          this.previewSrc = `${res.retValue}`
          this.previewStuff = 'audio'
        } else {
          this.previewSrc = `${res.retValue}`
          this.previewStuff = 'pic'
        }
        this.previewDialogVisible = true
      })
    },
    selectFloderHandler(val) {
      this.getFileList({
        folderId: val,
        flag: 2,
      }).then(res => {
        this.fileList = res.retValue
      })
    },
    async getStudyIds() {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupQuestionListServiceGetStudyIds',
        params: {
          seatId: this.userid,
          taskId: this.$route.query.taskId
        }
      })
      return result
    },
    getFolderList(p) {
      this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceGetFolderNameList',
        params: {
          followUpTaskId: this.$route.query.taskId,
          flag: p.flag
        }
      }).then(res => {
        console.log(res);
        this.floderList = res.retValue
      })
    },
    async getFileList(p) {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceGetFileListByTaskId',
        params: {
          folderId: p.folderId,
          flag: p.flag,
          taskId: this.$route.query.taskId
        }
      })
      return result
    },
    watermark(settings) {
      //默认设置
      var defaultSettings = {
        watermark_txt: `上海荟医信息科技有限公司${this.username}${this.userid}`,
        watermark_x: 10, //水印起始位置x轴坐标
        watermark_y: 10, //水印起始位置Y轴坐标
        watermark_rows: 4, //水印行数
        watermark_cols: 8, //水印列数
        watermark_x_space: 50, //水印x轴间隔
        watermark_y_space: 150, //水印y轴间隔
        watermark_color: '#666', //水印字体颜色
        watermark_alpha: 0.10, //水印透明度
        watermark_fontsize: '15px', //水印字体大小
        watermark_font: '黑体', //水印字体
        watermark_width: 180, //水印宽度
        watermark_height: 80, //水印长度
        watermark_angle: 20 //水印倾斜度数
      };
      if (arguments.length === 1 && typeof arguments[0] === "object") {
        var src = arguments[0] || {};
        for (key in src) {
          if (src[key] && defaultSettings[key] && src[key] === defaultSettings[key]) continue;
          else if (src[key]) defaultSettings[key] = src[key];
        }
      }
      var oTemp = document.createDocumentFragment();
      let element = document.getElementById('studyPage')
      console.log(element);
      //获取页面最大宽度
      var page_width = Math.max(element.scrollWidth, element.clientWidth);
      var cutWidth = page_width * 0.0150;
      var page_width = page_width - cutWidth;
      //获取页面最大高度
      var page_height = Math.max(element.scrollHeight, element.clientHeight) + 450;
      page_height = Math.max(page_height, window.innerHeight - 30);
      //如果将水印列数设置为0，或水印列数设置过大，超过页面最大宽度，则重新计算水印列数和水印x轴间隔
      if (defaultSettings.watermark_cols == 0 || (parseInt(defaultSettings.watermark_x + defaultSettings.watermark_width * defaultSettings.watermark_cols + defaultSettings.watermark_x_space * (defaultSettings.watermark_cols - 1)) > page_width)) {
        defaultSettings.watermark_cols = parseInt((page_width - defaultSettings.watermark_x + defaultSettings.watermark_x_space) / (defaultSettings.watermark_width + defaultSettings.watermark_x_space));
        defaultSettings.watermark_x_space = parseInt((page_width - defaultSettings.watermark_x - defaultSettings.watermark_width * defaultSettings.watermark_cols) / (defaultSettings.watermark_cols - 1));
      }
      //如果将水印行数设置为0，或水印行数设置过大，超过页面最大长度，则重新计算水印行数和水印y轴间隔
      if (defaultSettings.watermark_rows == 0 || (parseInt(defaultSettings.watermark_y + defaultSettings.watermark_height * defaultSettings.watermark_rows + defaultSettings.watermark_y_space * (defaultSettings.watermark_rows - 1)) > page_height)) {
        defaultSettings.watermark_rows = parseInt((defaultSettings.watermark_y_space + page_height - defaultSettings.watermark_y) / (defaultSettings.watermark_height + defaultSettings.watermark_y_space));
        defaultSettings.watermark_y_space = parseInt(((page_height - defaultSettings.watermark_y) - defaultSettings.watermark_height * defaultSettings.watermark_rows) / (defaultSettings.watermark_rows - 1));
      }
      var x;
      var y;
      for (var i = 0; i < defaultSettings.watermark_rows; i++) {
        y = defaultSettings.watermark_y + (defaultSettings.watermark_y_space + defaultSettings.watermark_height) * i;
        for (var j = 0; j < defaultSettings.watermark_cols; j++) {
          x = defaultSettings.watermark_x + (defaultSettings.watermark_width + defaultSettings.watermark_x_space) * j;
          var mask_div = document.createElement('div');
          mask_div.id = 'mask_div' + i + j;
          mask_div.className = 'mask_div';
          mask_div.appendChild(document.createTextNode(defaultSettings.watermark_txt));
          //设置水印div倾斜显示
          mask_div.style.webkitTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
          mask_div.style.MozTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
          mask_div.style.msTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
          mask_div.style.OTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
          mask_div.style.transform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
          mask_div.style.visibility = "";
          mask_div.style.position = "absolute";
          mask_div.style.left = x + 'px';
          mask_div.style.top = y + 'px';
          mask_div.style.overflow = "hidden";
          mask_div.style.zIndex = "9999";
          //让水印不遮挡页面的点击事件
          mask_div.style.pointerEvents = 'none';
          mask_div.style.opacity = defaultSettings.watermark_alpha;
          mask_div.style.fontSize = defaultSettings.watermark_fontsize;
          mask_div.style.fontFamily = defaultSettings.watermark_font;
          mask_div.style.color = defaultSettings.watermark_color;
          mask_div.style.textAlign = "center";
          mask_div.style.width = defaultSettings.watermark_width + 'px';
          mask_div.style.height = defaultSettings.watermark_height + 'px';
          mask_div.style.display = "block";
          oTemp.appendChild(mask_div);
        }
        ;
      }
      ;
      element.appendChild(oTemp);
    },
    init() {
      this.getFollowUpTaskAllSpotCheck()
          .then(() => {
            if (this.spotCheckList.length) {
              this.getPatientDetail(this.spotCheckList[0])
              this.drawer = false
            }

          })
      this.getStudyIds()
          .then(idRes => {
            this.getStudyListByTaskAsync({
              taskId: this.$route.query.taskId
            })
                .then(res => {
                  this.studyList = res.retValue.map(item => {
                    if (idRes.retValue.find(it => it == item.studyId)) {
                      item.showDot = true
                    }
                    return item
                  })
                })
          })

    },
    currentChange(page) {
      console.log(page);
      this.spotCheckParams.pageIndex = page
      this.getFollowUpTaskAllSpotCheck()
    },
    onlyGood() {
      this.spotCheckParams.pageIndex = 1
      this.spotCheckParams.qualityScreen = this.spotCheckParams.qualityScreen == 1 ? 0 : 1
      this.getFollowUpTaskAllSpotCheck()
    },
    getSeatsByTaskId() {
      let taskId = this.$route.query.taskId
      let params = {
        followUpTaskId: taskId
      }
      this.getSeatsByTaskIdAsync(params)
          .then(res => {
            if (res.status == 0) {
              this.seatList = res.retValue
            }
          })

    },
    getFollowUpTaskAllSpotCheck() {
      return new Promise(resolve => {
        let taskId = this.$route.query.taskId
        console.log(taskId);
        let params = {
          seatId: this.spotCheckParams.seatId,
          taskId: taskId,
          pageIndex: this.spotCheckParams.pageIndex,
          pageSize: 10,
          qualityScreen: this.spotCheckParams.qualityScreen,
        }
        this.getFollowUpTaskAllSpotCheckAsync(params)
            .then(res => {
              console.log(res);
              if (res.status == 0) {
                this.spotCheckList = res.retValue.map(item => {
                  this.$store.dispatch('getFollowupStatus', {status: item.followStatus})
                      .then(status => {
                        item.followStatus = status
                      })
                  return item
                })
                this.spotCheckParams.totalPage = res.totalPage
                resolve()
              }
            })
      })
    },
    getPatientDetail(item) {
      this.showAudio = false
      this.asyncGetNormalPatientInfo({
        userId: item.seatUserInfos.id,
        followupPatientId: item.followupPatientId,
        taskId: this.$route.query.taskId
      }).then(res => {
        this.patientData = res.retValue
        this.showComponent = false
        this.currentSpotCheck = item
        setTimeout(() => {
          this.showComponent = true
        }, 100)
        this.getPatientRecordByPatientIdAsync({
          patientId: item.taskPatientInfoId
        })
            .then(record => {
              this.audioList = record.retValue
              this.audioSrc = ""
              this.drawer = false
              this.showAudio = true
              this.selectAudioId = null
            })
      })
    },
    getStudyById(item) {
      this.getStudyByIdAsync({
        studyId: item.studyId
      }).then(res => {
        this.studyTitle = item
        this.studyContent = res.retValue
        this.showArticleDetail = true
        this.$store.dispatch('requestHandler', {
          fn: 'RestNewFollowupQuestionListServiceDeleteMiddleTableRecord',
          params: {
            seatId: this.userid,
            taskId: this.$route.query.taskId,
            studyId: item.studyId
          }
        }).then(res => {
          if (res.status == 0) {
            this.$delete(item, 'showDot')
          }
        })
        // setTimeout(() => {
        //     this.watermark()
        // },300)
      })
    },
    //==========================request ==============================
    async getStudyListByTaskAsync(p) {
      let request = new RestNewFollowupCallCenterServiceGetStudyListByTask()
      request.p_taskId = p.taskId
      request.p_isAdd = true
      await request.send()
      return request.result
    },
    async getRecordList() {
      this.showA = false
      let audio = this.audioList.find(item => item.id == this.selectAudioId)
      let request = new RestNewFollowupCallCenterServiceGetALiRecording()
      request.p_contactId = audio.contactId
      await request.send()
      if (request.result.retValue.length) {
        this.audioSrc = JSON.parse(request.result.retValue[0])
        this.showA = true
      } else {
        this.$message.error('暂无录音')
      }
    },
    async getFollowUpTaskAllSpotCheckAsync(p) {
      let request = new RestNewFollowupCallCenterServiceGetFollowUpTaskAllSpotCheck()
      request.p_taskId = p.taskId
      request.p_nowUserId = sessionStorage.getItem('userid')
      request.p_seatId = p.seatId || null
      request.p_patientId = p.patientId || null
      request.p_qualityScreen = p.qualityScreen || null
      request.p_pageIndex = p.pageIndex
      request.p_pageSize = p.pageSize
      await request.send()
      return request.result
    },
    async getSeatsByTaskIdAsync(p) {
      let request = new RestNewFollowupCallCenterServiceGetSeatsByTaskId()
      request.p_followUpTaskId = p.followUpTaskId
      await request.send()
      return request.result
    },
    async asyncGetNormalPatientInfo(params) {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceGetFollowupTaskPatientInfo();
      info.p_userId = params.userId;
      info.p_followupPatientId = params.followupPatientId || null
      info.p_followupTaskId = params.taskId || null;
      await info.send()
      if (info.result.status == 0) {
        return info.result
      }
    },
    async getPatientRecordByPatientIdAsync(p) {
      let request = new RestFeedbackOutControllerGetFollowUpTaskPatientCallRecordList()
      request.p_followUpPatientInfoId = p.patientId
      await request.send()
      return request.result
    },
    async getStudyByIdAsync(p) {
      let request = new RestNewFollowupCallCenterServiceGetStudyById()
      request.p_studyId = p.studyId
      await request.send()
      return request.result
    },
  }
}
</script>
<style>
.viewer-container {
  z-index: 99999 !important;
}
</style>
<style lang="scss" scoped>
$height: 1020px - 96px - 60px;

.study-container {
  width: 100vw;

  .main-left {
    .main-left-search {
      display: flex;
      padding: 15px;
      justify-content: space-between;

      .only {
        &.active {
          color: #248cfa;
        }
      }
    }
  }
}

.el-main {
  //min-height: calc(100vh-96px-60px);
  width: 100%;
  // min-height: $height;
  margin: 0px;
  padding: 0px;
  height: calc(100vh - 120px);
  overflow: auto;
}

.main {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;

  .draw-bar {
    position: absolute;
    cursor: pointer;
    left: 0;
    top: 45%;
    width: 50px;
    height: 100px;
    z-index: 2000;
    background-color: rgba(219, 228, 242, 0.46);
    border: 1px solid rgba(196, 211, 235, 0.6);
    box-shadow: 1px 2px 2px rgba(71, 97, 164, 0.25);
    border-radius: 0px 8px 8px 0px;
    line-height: 50px;
    opacity: 0.7;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 10px;

    .bar-left {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      > span {
        line-height: 20px;
        font-weight: 700;
      }

      margin-right: 5px;
    }

    .bar-right {
      display: flex;
      align-items: center;
    }
  }

  .page-left {
    padding: 15px;

    .checklist {
      width: 300px;
      text-align: left;
      white-space: pre-wrap;

    }
  }

  .page-center {
    flex: 4;
    height: 800px;
    padding: 15px 0;

    .audio-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      /*border: 1px solid #ccc;*/
      border-radius: 5px;
      padding: 0 15px;
      margin-bottom: 15px;
      width: 100%;

      .select-bar {
        width: 20%;
      }

      .audio-item {
        width: 80%;
      }
    }
  }

  .page-right {
    flex: 3;
    width: 30%;
    padding: 15px 0;
    margin-left: 15px;
    text-align: left;

    .article-detail, .articleList {
      height: $height;
      padding: 15px 15px;
      border-radius: 5px;
      width: 100%;
      overflow: auto;

    }

    .articleList {


    }
    .article-item {
      text-align: left;
      padding: 15px 0;
      border-bottom: 1px solid #ccc;
      cursor: pointer;

      &:last-child {
        border-bottom: none;
      }
    }
  }
}

.drawer-inner-list {
  padding: 0 15px;
  height: 90%;
  overflow: auto;

  .list-item {
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: space-between;
    padding: 25px 0;
    border-bottom: 1px solid #ccc;
  }
}

.study-detail {
  display: flex;
  justify-content: space-around;

  .label-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 10px;
    cursor: pointer;

    .one {
      width: 5px;
      background-color: #248cfa;
      height: 20px;
      margin-left: 10px;
      margin-right: 8px;
    }
  }

  .study-label {
    font-size: 18px;
    //color: 18px;
    font-weight: bold;

  }

  .study-left {
    margin-top: 15px;
    min-height: 700px;
    height: 800px;
    overflow: scroll;
    width: 100%;
    background-color: #fff;
  }

  .study-right {
    margin-top: 15px;
    width: 100%;
    background-color: #fff;

    .article-detail {
      min-height: 600px;
      height: 760px;
      overflow: scroll;
      padding: 15px;
    }

    .study-list {
      padding-left: 10px;
      padding-right: 10px;
      min-height: 600px;
      height: 770px;
      overflow: scroll;

      .article-item {
        display: flex;
        justify-content: space-between;
        height: 40px;
        cursor: pointer;
        align-items: center;
      }
    }
  }
}

</style>
